<ng-container *ngrxLet="selectEarlyAdopterPlanWithPrices$; let product">
  <div *ngIf="product">
    {{ product | json }}
  </div>
</ng-container>
